"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatesContainer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var polished_1 = require("polished");
var styled_components_1 = require("styled-components");
var window_size_1 = require("@react-hook/window-size");
var mujer_sonriente_compras_linea_laptop_tarjeta_credito_jpg_1 = __importDefault(require("@static/img/jpg/mujer-sonriente-compras-linea-laptop-tarjeta-credito.jpg"));
var styles_1 = require("./styles");
function RatesContainer(_a) {
    var containerStyle = _a.containerStyle, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? 'purple' : _b;
    var widthSize = (0, window_size_1.useWindowWidth)();
    var colors = (0, styled_components_1.useTheme)().colors;
    var borderRadius = (0, polished_1.rem)(20);
    var pricesStyle = {
        width: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };
    var trPriceStyle = {
        width: '100%',
        display: 'flex',
        // backgroundColor: colors.white,
        borderTopRightRadius: borderRadius,
        borderBottomRightRadius: borderRadius,
        height: 69,
    };
    var tdPrimaryColumn = {
        borderTopLeftRadius: borderRadius,
        borderBottomLeftRadius: borderRadius,
        backgroundColor: colors.white,
    };
    var styleTdTitle = {
        height: (0, polished_1.rem)(50),
        color: backgroundColor === 'purple' ? colors.white : colors.purple[500],
    };
    var styleBorderRight = {
        borderRight: "".concat((0, polished_1.rem)(2), " solid ").concat(colors.purple[500]),
    };
    var styleBorderLeft = {
        borderLeft: "".concat((0, polished_1.rem)(2), " solid ").concat(colors.purple[500]),
    };
    return ((0, jsx_runtime_1.jsx)(styles_1.Container, __assign({ style: containerStyle, backgroundColor: backgroundColor }, { children: (0, jsx_runtime_1.jsxs)(styles_1.ContainerContainer, { children: [(0, jsx_runtime_1.jsx)(styles_1.RightContainer, { children: (0, jsx_runtime_1.jsx)("img", { src: mujer_sonriente_compras_linea_laptop_tarjeta_credito_jpg_1.default, alt: "mujer sonriente compras linea laptop tarjeta credito" }) }), (0, jsx_runtime_1.jsxs)(styles_1.LeftContainer, __assign({ backgroundColor: backgroundColor }, { children: [(0, jsx_runtime_1.jsx)("h1", { children: "Tarifa" }), (0, jsx_runtime_1.jsxs)("h2", { children: ["\u00A1Solo por ", widthSize > 650 && (0, jsx_runtime_1.jsx)("br", {}), " transacci\u00F3n exitosa!"] }), (0, jsx_runtime_1.jsxs)("ul", { children: [(0, jsx_runtime_1.jsx)("li", { children: "Sin costo de afiliaci\u00F3n" }), (0, jsx_runtime_1.jsx)("li", { children: "Sin costo de mantenimiento" }), (0, jsx_runtime_1.jsx)("li", { children: "Las tarifas no incluyen IVA" })] })] }))] }) })));
}
exports.RatesContainer = RatesContainer;
function _CardConditions(_a) {
    var backgroundColor = _a.backgroundColor;
    return ((0, jsx_runtime_1.jsx)(styles_1.ContainerConditions, __assign({ backgroundColor: backgroundColor }, { children: (0, jsx_runtime_1.jsx)("p", { children: "**Esta solo se aplica cuando exista un contracargo por alguna controversia en la transacci\u00F3n emitida por el banco emisor." }) })));
}
